<template>
  <div class="container-xxl">
    <div class="authentication-wrapper authentication-basic container-p-y">
      <div class="authentication-inner py-6">
        <!-- Login -->
        <div class="card">
          <div v-if="enabled" class="card-body">
            <!-- Logo -->
            <div class="app-brand justify-content-center mb-10">
              <a href="login.php" class="app-brand-link">
                <div class="" style="width: 3.5rem;">
                  <img src="../assets/img/logo-icon.svg" alt />
                </div>
                <span
                  class="app-brand-text demo menu-text fw-bold"
                  style="width: 10.5rem;"
                >
                  <img src="../assets/img/logo-text.svg" alt />
                </span>
              </a>
            </div>
            <!-- /Logo -->

            <form
              id="formAuthentication"
              class="mb-4"
              action="index.html"
              method="GET"
            >
              <div class="mb-6" v-if="licensed && !no_realm">
                <label for="Realm" class="form-label">{{
                  $t("login.realm")
                }}</label>
                <input
                  v-model="user.realm"
                  type="text"
                  class="form-control"
                  id="Realm"
                  name="realm"
                  placeholder="Realm"
                  autofocus
                />
              </div>
              <div class="mb-6" v-if="licensed">
                <label for="username" class="form-label">{{
                  $t("login.username")
                }}</label>
                <input
                  v-model="user.email"
                  type="text"
                  class="form-control"
                  id="username"
                  name="username"
                  :placeholder="`${$t('login.enter_username')}`"
                  autofocus
                />
              </div>
              <div class="mb-6 form-password-toggle" v-if="licensed">
                <label class="form-label" for="password">{{
                  $t("login.password")
                }}</label>
                <div class="input-group input-group-merge">
                  <input
                    v-model="user.password"
                    type="password"
                    id="password"
                    class="form-control"
                    name="password"
                    placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                    aria-describedby="password"
                  />
                  <span class="input-group-text cursor-pointer"
                    ><i class="ti ti-eye-off"></i
                  ></span>
                </div>
              </div>
              <div class="my-8" v-if="licensed">
                <div class="d-flex justify-content-between">
                  <div class="form-check mb-0 ms-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="remember-me"
                    />
                    <label class="form-check-label" for="remember-me">
                      {{ $t("login.remember_me") }}
                    </label>
                  </div>
                  <a href="https://wa.me/31685757294">
                    <p class="mb-0">{{ $t("login.forgot_password") }}</p>
                  </a>
                </div>
              </div>
              <div class="mb-6" v-if="licensed">
                <button
                  class="btn btn-primary d-grid w-100"
                  @click.prevent="store"
                  type="submit"
                >
                  <div v-if="!loading">{{ $t("login.login") }}</div>
                  <div v-if="loading" class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </button>
                <div v-if="errorMessage" class="text-danger text-center mt-2">
                  {{ errorMessage }}
                </div>
              </div>
              <div v-if="!licensed" class="mb-6" dir="ltr">
                <label for="username" class="form-label">{{
                  $t("login.serial_number")
                }}</label>
                <div class="d-flex gap-1 text-center">
                  <input
                    v-model="serial.first"
                    tabindex="1"
                    maxlength="4"
                    size="4"
                    type="text"
                    class="form-control text-center"
                    placeholder="XXXX"
                  />
                  <input
                    v-model="serial.second"
                    tabindex="2"
                    maxlength="4"
                    size="4"
                    type="text"
                    class="form-control text-center"
                    placeholder="XXXX"
                  />
                  <input
                    v-model="serial.third"
                    tabindex="3"
                    maxlength="4"
                    size="4"
                    type="text"
                    class="form-control text-center"
                    placeholder="XXXX"
                  />
                  <input
                    v-model="serial.forth"
                    tabindex="4"
                    maxlength="4"
                    size="4"
                    type="text"
                    class="form-control text-center"
                    placeholder="XXXX"
                  />
                </div>
              </div>
              <div class="mb-6" v-if="!licensed">
                <button
                  class="btn btn-primary d-grid w-100"
                  tabindex="5"
                  @click.prevent="activateLicense"
                  type="submit"
                >
                  <div v-if="!loading">{{ $t("login.license") }}</div>
                  <div v-if="loading" class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </button>
                <div v-if="errorMessage" class="text-danger text-center mt-2">
                  {{ errorMessage }}
                </div>
              </div>
            </form>
          </div>
          <div v-else class="card-body text-center">
            <h4>{{ $t("login.internal_server_error") }}</h4>
          </div>
        </div>
        <!-- /Register -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      user: {
        realm: "",
        email: "",
        password: "",
      },
      licensed: true,
      enabled: true,
      no_relam: false,
      errorMessage: null,
      no_realm: false,
      serial: {
        first: "",
        second: "",
        third: "",
        forth: "",
      },
    };
  },
  created() {
    if (localStorage.getItem("realm") != null) {
      this.user.realm = localStorage.getItem("realm");
    }
    this.checkLicense();
  },
  methods: {
    async store() {
      this.loading = true;
      if (
        !this.no_realm &&
        this.user.realm != "local" &&
        this.user.realm != "radius"
      ) {
        var auth_url = "https://auth.ssradius.com/";
        const keyResponse = await axios.post(auth_url + "api/key", {
          token: "equlize123$$$$",
          realm: this.user.realm,
        });
        if (keyResponse.status == 200) {
          const curr_url = window.location.origin;
          localStorage.setItem("server", `${curr_url}/${this.user.realm}/`);
          // localStorage.setItem(
          //   "server_api",
          //   `https://${window.location.hostname}/${this.user.realm}/api/`
          // );
          localStorage.setItem(
            "server_api",
            `${curr_url}/${this.user.realm}/api/`
          );
        } else if (keyResponse.status == 204) {
          this.formError = true;
          this.loading = false;
          this.errorMessage = "Realm Disabled";
          return;
        } else {
          this.formError = true;
          this.loading = false;
          this.errorMessage = "Invalid Realm";
          return;
        }
      }
      if (this.user.realm == "local") {
        localStorage.setItem("server", "http://localhost:8000/");
        localStorage.setItem("server_api", "http://localhost:8000/api/");
      }
      if (this.user.realm == "radius") {
        localStorage.setItem("server", "http://ssradius.test/server/");
        localStorage.setItem("server_api", "http://ssradius.test/server/api/");
      }
      if (this.user.realm == "test") {
        localStorage.setItem("server", "https://s1.ssradius.com/864444/");
        localStorage.setItem(
          "server_api",
          "https://s1.ssradius.com/864444/api/"
        );
      }
      if (this.no_realm) {
        const curr_url = window.location.origin;
        localStorage.setItem("server", curr_url + "/server/");
        localStorage.setItem("server_api", curr_url + "/server/api/");
      }
      axios.defaults.baseURL = localStorage.getItem("server_api");

      try {
        // const res = await axios.post("users/login", {
        //   email: this.email,
        //   password: this.password,
        // });
        // localStorage.setItem("token", res.data.token);
        // axios.defaults.headers.common["Authorization"] =
        //   "Bearer " + localStorage.getItem("token");
        var cookieRes = await axios.get(
          localStorage.getItem("server") + "sanctum/csrf-cookie"
        );
        if (cookieRes.status == 204 || cookieRes.status == 200) {
          const loginRes = await axios.post("/users/login", {
            email: this.user.email,
            password: this.user.password,
          });
          if (loginRes.status == 210) {
            this.formError = true;
            this.loading = false;
            this.errorMessage = "Invalid Username or Password";
            return;
          } else if (loginRes.status == 261) {
            this.formError = true;
            this.loading = false;
            this.errorMessage = "License Error";
            return;
          } else if (loginRes.status == 269) {
            this.formError = true;
            this.loading = false;
            this.errorMessage = "Check internet connection";
            return;
          } else if (loginRes.status == 200) {
            const responseSettings = await axios.get("settings");
            this.$store.dispatch("settings", responseSettings.data.data);
            // this.$i18n.locale = responseSettings.data.data.language;
            const responseUser = await axios.get("user");
            localStorage.setItem("realm", this.user.realm);
            this.$store.dispatch("user", responseUser.data.data);
            this.$router.push("/");
            this.loading = false;
          } else if (loginRes.response && loginRes.response.status == 500) {
            this.formError = true;
            this.loading = false;
            this.errorMessage = loginRes.response.data.message;
          }
        }
      } catch (e) {
        this.formError = true;
        this.loading = false;
        this.errorMessage = "SERVER ERROR";
        console.log(e);
      }
    },
    async checkLicense() {
      const curr_url = window.location.origin;
      if (
        curr_url == "http://localhost:8080" ||
        curr_url == "https://s1.ssradius.com" ||
        curr_url == "https://s2.ssradius.com" ||
        curr_url == "https://s3.ssradius.com"
      )
        return;
      try {
        const response = await axios.get(curr_url + "/server/api/check");
        switch (response.status) {
          case 200:
            this.licensed = true;
            if (response.data == "licensed") {
              this.no_realm = true;
            }
            break;
          case 230:
            this.licensed = false;
            this.$notify({
              title: this.$t("login.license_error"),
              message: this.$t("login.no_license_found"),
              type: "error",
            });
            break;
          case 235:
            this.licensed = false;
            this.$notify({
              title: this.$t("login.license_error"),
              message: this.$t("login.license_error"),
              type: "error",
            });
            break;
          case 250:
            this.$notify({
              title: this.$t("login.database_error"),
              message: this.$t("login.db_connection_failed"),
              type: "error",
            });
            break;
          case 500:
            this.$notify({
              title: this.$t("login.internal_server_error"),
              message: response.data,
              type: "error",
            });
            this.enabled = false;
            break;
        }
        if (response.response && response.response.status == 500) {
          this.$notify({
            title: this.$t("login.internal_server_error"),
            message: response.response.data.substring(0, 100),
            type: "error",
          });
          this.enabled = false;
        }
      } catch (error) {
        this.$notify({
          title: this.$t("login.internal_server_error"),
          message: this.$t("login.internal_server_error"),
          type: "error",
        });
        this.enabled = false;
      }
    },
    async activateLicense() {
      const curr_url = window.location.origin;
      try {
        const serial =
          this.serial.first +
          "-" +
          this.serial.second +
          "-" +
          this.serial.third +
          "-" +
          this.serial.forth;
        const response = await axios.post(curr_url + "/server/api/activate", {
          serial: serial,
        });
        if (response.status == 200) {
          this.$notify({
            title: this.$t("login.activated_successfully"),
            message: this.$t("login.license_activated_successfully"),
            type: "success",
          });
          this.licensed = true;
        } else {
          this.licensed = false;
          this.$notify({
            title: this.$t("login.license_error"),
            message: this.$t("login.license_error"),
            type: "error",
          });
        }
      } catch (error) {
        this.licensed = false;
        this.$notify({
          title: this.$t("login.server_error"),
          message: this.$t("login.error_connecting_to_verfication_server"),
          type: "error",
        });
      }
      await this.checkLicense();
    },
  },
};
</script>
